import React, {FC, useEffect, useRef, useState} from 'react';
import {getMapLayersProps} from "@ui/leafletCustom/titleLayer/helpers/getMapLayersProps";
import {TileLayer} from 'react-leaflet';
import SelectTitleLayer from "./selectTitleLayer/SelectTitleLayer";
import {SetStatePropsType} from "@baseTypes/base";

interface IProps {
    titleLayer: string,
    setTitleLayer: SetStatePropsType<string>
}

const LeafletTitleLayer: FC<IProps> = ({
                                           titleLayer,
                                           setTitleLayer,
                                       }) => {

    const ref = useRef()
    const [show, setShow] = useState<boolean>(true)

    useEffect(() => {
        setShow(false)
        setTimeout(() => {
            setShow(true)
        }, 100)
    }, [titleLayer]);

    if (!show) {
        return
    }
    return (
        <>
            <SelectTitleLayer
                url={titleLayer}
                setUrl={setTitleLayer}
            />

            <TileLayer
                ref={ref}
                {...getMapLayersProps(titleLayer)}
            />
        </>
    );
};

export default LeafletTitleLayer;